/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Data_AccountInputs */

const da_privacy_data_account = /** @type {(inputs: Privacy_Data_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`**Konto:** navn, e-mailadresse og adgangskode (den gemmes kun som en envejskrypteret kode, så vi ikke kan læse den) og om e-mailadressen er bekræftet.`)
};

/** @type {(inputs: Privacy_Data_AccountInputs) => LocalizedString} */
const en_privacy_data_account = da_privacy_data_account;

/**

* @param {Privacy_Data_AccountInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_data_account = /** @type {((inputs?: Privacy_Data_AccountInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Data_AccountInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_data_account(inputs)
	return /** @type {LocalizedString} */ ("**Konto:** navn, e-mailadresse og adgangskode (den gemmes kun som en envejskrypteret kode, så vi ikke kan læse den) og om e-mailadressen er bekræftet.")
});